export default __webpack_public_path__ + "robot.png";